/*
 * UTM Capture v4 — First/last touch attribution + click-ID fallback.
 * Stocke les UTM dans localStorage et les synchronise sur les attributs du panier.
 * Ce code doit s'exécuter avant tout autre script pour capter les UTM dès le chargement.
 */
(function () {
  /* Helpers localStorage résistants aux erreurs (navigation privée, quota dépassé) */
  function getLS(key) {
    try { return localStorage.getItem(key) || ''; } catch (e) { return ''; }
  }
  function setLS(key, value) {
    try { localStorage.setItem(key, value); } catch (e) { /* silencieux */ }
  }

  const params = new URLSearchParams(window.location.search);

  /* Si un paramètre apparaît plusieurs fois (UTM manuels + auto-tagging),
     on prend la DERNIÈRE valeur = celle de l'auto-tagging (Bing, Google, etc.) */
  function getLast(key) {
    const all = params.getAll(key);
    return all.length ? all[all.length - 1] : '';
  }

  const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  let hasUtm = false;

  utmKeys.forEach(key => {
    const val = getLast(key);
    if (val) {
      hasUtm = true;

      if (!getLS(`first_${key}`)) {
        setLS(`first_${key}`, val);
      }

      setLS(`last_${key}`, val);
    }
  });

  /*
   * Click-ID fallback : quand un clic pub arrive sans UTM explicites,
   * on déduit la source à partir du click-ID présent dans l'URL.
   * - gclid   → Google Ads
   * - fbclid  → Meta (Facebook / Instagram)
   * - msclkid → Microsoft Ads (Bing)
   */
  const clickIdEntries = [
    { param: 'gclid',   source: 'gclid',   medium: 'cpc' },
    { param: 'fbclid',  source: 'fbclid',  medium: 'paid_social' },
    { param: 'msclkid', source: 'msclkid', medium: 'cpc' }
  ];

  for (const { param, source, medium } of clickIdEntries) {
    const clickIdValue = getLast(param);
    if (!clickIdValue) continue;

    // Stocker le click-ID brut (utile pour le suivi des conversions côté serveur)
    if (!getLS(`first_${param}`)) {
      setLS(`first_${param}`, clickIdValue);
    }
    setLS(`last_${param}`, clickIdValue);

    // Fallback : remplir utm_source/utm_medium seulement s'ils sont absents de l'URL
    if (!getLast('utm_source')) {
      hasUtm = true;

      if (!getLS('first_utm_source')) {
        setLS('first_utm_source', source);
      }
      setLS('last_utm_source', source);

      if (!getLast('utm_medium')) {
        if (!getLS('first_utm_medium')) {
          setLS('first_utm_medium', medium);
        }
        setLS('last_utm_medium', medium);
      }
    }

    break; // Un seul click-ID pertinent par visite
  }

  if (hasUtm && !getLS('first_landing_page')) {
    setLS('first_landing_page', window.location.href);
  }

  setLS('last_page', window.location.href);

  function sanitizeOneLine(v) {
    return String(v || '')
      .replace(/[\r\n\t]+/g, ' ')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  function buildUtmPayload() {
    return {
      first_utm_source: sanitizeOneLine(getLS('first_utm_source')),
      first_utm_medium: sanitizeOneLine(getLS('first_utm_medium')),
      first_utm_campaign: sanitizeOneLine(getLS('first_utm_campaign')),
      first_utm_content: sanitizeOneLine(getLS('first_utm_content')),
      first_utm_term: sanitizeOneLine(getLS('first_utm_term')),

      last_utm_source: sanitizeOneLine(getLS('last_utm_source')),
      last_utm_medium: sanitizeOneLine(getLS('last_utm_medium')),
      last_utm_campaign: sanitizeOneLine(getLS('last_utm_campaign')),
      last_utm_content: sanitizeOneLine(getLS('last_utm_content')),
      last_utm_term: sanitizeOneLine(getLS('last_utm_term')),

      first_landing_page: sanitizeOneLine(getLS('first_landing_page')),
      last_page: sanitizeOneLine(getLS('last_page')),

      first_gclid: sanitizeOneLine(getLS('first_gclid')),
      last_gclid: sanitizeOneLine(getLS('last_gclid')),
      first_fbclid: sanitizeOneLine(getLS('first_fbclid')),
      last_fbclid: sanitizeOneLine(getLS('last_fbclid')),
      first_msclkid: sanitizeOneLine(getLS('first_msclkid')),
      last_msclkid: sanitizeOneLine(getLS('last_msclkid')),

      version: '4'
    };
  }

  function hasAnyUtmValue(payload) {
    // Ne pas envoyer un JSON vide si tout est vide
    return Object.entries(payload).some(([k, v]) => k !== 'version' && (v || '').trim() !== '');
  }

  async function syncToCart() {
    const payload = buildUtmPayload();
    if (!hasAnyUtmValue(payload)) return;

    const attributes = {
      utm_json: JSON.stringify(payload)
    };

    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes }),
        keepalive: true
      });
    } catch (e) {
      // silencieux volontairement
    }
  }

  // Sync immédiat
  syncToCart();

  // Sync aussi quand on clique sur un bouton checkout
  document.addEventListener('click', function (e) {
    const el = e.target && e.target.closest ? e.target.closest('a,button') : null;
    if (!el) return;

    const href = (el.getAttribute('href') || '').toLowerCase();
    const name = (el.getAttribute('name') || '').toLowerCase();

    const looksLikeCheckout =
      href.includes('/checkout') ||
      name.includes('checkout') ||
      el.className.toLowerCase().includes('checkout');

    if (looksLikeCheckout) {
      syncToCart();
    }
  }, true);
})();
